module.exports = __webpack_public_path__ + "img/1447513097.4a750e3b.jpg";